// Runtime config injected via /config.js. Falls back to dev defaults so
// `npm run dev` works locally without a server.
const cfg = window.__ONGUARD_CONFIG__ || {};

export const config = {
  apiUrl: cfg.apiUrl || 'http://localhost:3000',
  cognitoUserPoolId: cfg.cognitoUserPoolId || '',
  // Main central app client (onguard-entraid): SSO sign-ins, idp_identifier only.
  cognitoUserPoolClientId: cfg.cognitoUserPoolClientId || '',
  // Native-only central app client (onguard-entraid-native, COGNITO only):
  // password sign-ins, so no federation button is shown. IPCMAN-1458.
  cognitoNativeClientId: cfg.cognitoNativeClientId || '',
  cognitoHostedUiDomain: cfg.cognitoHostedUiDomain || '',
  // Central provisioning API base URL. Used before sign-in for login-method
  // discovery (GET /discover?email=). Injected at deploy time.
  provisioningApiUrl: cfg.provisioningApiUrl || '',
  portalDomain: cfg.portalDomain || window.location.host,
  // 'Production' or 'Test', injected by deploy-portal.sh. Anything else (a
  // local `npm run dev`, tests) counts as NON-PROD for the app switcher.
  environment: cfg.environment || 'Development',
  // Public-read S3 base URL where customer-facing CloudFormation templates
  // live. Injected at deploy time so the SPA never hardcodes the bucket name.
  templatesBaseUrl: cfg.templatesBaseUrl || '',
  portalLambdaRoleArn: cfg.portalLambdaRoleArn || '',
};
